// Extract error key from our API shape
const getApiErrorKey = (error) =>
  error?.response?.errors?._error ??
  error?.errors?._error ??
  error?.response?.errors?.error ??
  error?.errors?.error

export default getApiErrorKey
